
import { store }                from '../../index';
import { SET_COMPONENTS_STATE } from 'actions';
import { objType }              from 'types';

const handleIsOver = ( variant: string ) => {

    const state              = store.getState();
    const componentsState    = state.components;
    const setComponentsState = (payload: objType) => store.dispatch(SET_COMPONENTS_STATE(payload))

    if ( variant === 'tens' && !componentsState.tens.isOver ) {
        const tens = {
          ...componentsState.tens,
          isOver: true
        }
        setComponentsState({ tens: tens })
      }
      if ( variant === 'units' && !componentsState.units.isOver ) {
        const units = {
          ...componentsState.units,
          isOver: true
        }
        setComponentsState({ units: units })
      }
}

export default handleIsOver;